import { useEffect, useRef } from 'react';
import { minBreakpoints } from 'presentation/theme/mediaQueries';
import { useMediaQuery } from './useMediaQuery';

const useAutoFocus = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const isMdOrAbove = useMediaQuery(`(min-width: ${minBreakpoints.md}px)`);

  useEffect(() => {
    if (inputRef.current && isMdOrAbove) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isMdOrAbove]);

  return inputRef;
};

export default useAutoFocus;
